import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ENTITLEMENTS, EntitlementsHelperService, LINE_OF_BUSINESS_ENUM, LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure, USER_ROLE } from '@ptl/account-management';
import { AuthoringModeService } from 'src/app/shared/services/authoring-mode.service';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ProducerReportDetails, ProducerReportDetailsResponse } from '../interfaces/reports-service.interface';
import { ProducerReportsService } from '../producer-reports.service';
import { GlobalShadowStyleDirective } from '@ptl/global-components';

@Component({
    selector: 'app-producer-reports-list',
    templateUrl: './producer-reports-list.component.html',
    styleUrls: ['./producer-reports-list.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class ProducerReportsListComponent extends GlobalShadowStyleDirective implements OnInit {

  @Input() noEntitlementsMessage: string;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('paginator') paginator: MatPaginator;

  hasEntitlements = false;
  reportFilter: UntypedFormGroup;
  columnsToDisplay = ['download', 'type', 'format', 'publishDate', 'reportId'];
  reportsToDisplay;

  constructor(
    private reportService: ProducerReportsService,
    private fb: UntypedFormBuilder,
    private authoringMode: AuthoringModeService,
    private entitlementsHelper: EntitlementsHelperService,
    private reducerUtilityService: ReducerUtilityService
  ) { 
    super();
  }

  async ngOnInit() {

    const lob: LINE_OF_BUSINESS_ENUM = await this.entitlementsHelper.getCurrentLobPromise();
    const loginData: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

    this.hasEntitlements = await this.entitlementsHelper.entitlementValueForSelectedAgencyByNameAndLob(ENTITLEMENTS.AGENCY_REPORTS, lob, loginData?.userInfo?.role as USER_ROLE);

    if (!this.authoringMode.getAuthoringMode() || this.hasEntitlements) {
      this.reportFilter = this.fb.group({
        reportFilterValue: this.fb.control('')
      });
    }

  }

  async ngAfterViewInit() {
    super.ngAfterViewInit();
    let response: ProducerReportDetailsResponse = await this.reportService.getReportsList();

    this.reportsToDisplay = new MatTableDataSource(response.payload.reports);
    this.reportsToDisplay.sort = this.sort;
    this.reportsToDisplay.paginator = this.paginator;

    // Override published date sorting to properly sort date objects and not string values
    this.reportsToDisplay.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'publishDate':
          return item.publishDate ? new Date(item.publishDate) : item.executionStatus;
        default:
          return item[property];
      }
    };

    // Configure the filter to match either type or report Id
    this.reportsToDisplay.filterPredicate = (data: ProducerReportDetails, filter: string) => {
      let filterValue = filter ? filter.toLowerCase() : '';
      return (data.type && data.type.toLowerCase().indexOf(filterValue) !== -1) || (data.reportId && data.reportId.toString().indexOf(filterValue) !== -1);
    };
  }

  async downloadReport(report: ProducerReportDetails) {
    report.isDownloadPending = true;
    await this.reportService.downloadReport(report.reportId);
    report.isDownloadPending = false;
  }

  applyFilter(filterValue: string) {
    this.reportsToDisplay.filter = filterValue;
  }
}
